import { useSelector } from '../../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../../app.store';

const searchActiveSelector = (state: AppState) => state.frontendState.mapTools.search.searchActive;
const searchTextSelector = (state: AppState) => state.frontendState.mapTools.search.searchText;

export const useSearchActiveSelector = () => useSelector(searchActiveSelector);
export const useSearchTextSelector = () => useSelector(searchTextSelector);
